module.exports = __webpack_public_path__ + "img/19.03e30380.jpg";